import { Controller } from "@hotwired/stimulus"
import * as echarts from "echarts"

export default class extends Controller {
  static targets = ["canvas"]
  static values = { data: Object, title: String }

  connect() {
    this.chart = echarts.init(this.canvasTarget)
    this.resizeHandler = () => this.chart.resize()
    window.addEventListener("resize", this.resizeHandler)
    this.render()
  }

  render() {
    const { labels, series } = this.dataValue

    const indicator = labels.map((name, index) => {
      const max = Math.max(0, ...series.map((s) => s.data[index] || 0))
      return { name, max: max || 1 }
    })

    this.chart.setOption({
      ...(this.titleValue ? { title: { text: this.titleValue, backgroundColor: 'white', textStyle: { color: 'black' } } } : {}),
      tooltip: {
        trigger: "item"
      },
      legend: {
        bottom: 0,
        type: "scroll"
      },
      toolbox: {
        feature: {
          saveAsImage: {
            name: this.titleValue || "radar-chart"
          }
        }
      },
      radar: {
        indicator,
        center: ["50%", this.titleValue ? "56%" : "50%"],
        radius: this.titleValue ? "58%" : "68%"
      },
      series: [
        {
          type: "radar",
          data: series.map((s) => ({ name: s.name, value: s.data }))
        }
      ]
    })
  }

  disconnect() {
    window.removeEventListener("resize", this.resizeHandler)

    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  }
}
